import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { CommonDropdownService } from '../../../common-dropdown.service';
import { PaginatedDropdown } from '../../../util/paginated-dropdown';
import { validateRequired } from '../../../util/validation.util';

@Component({
  selector: 'app-account-aging',
  templateUrl: './account-aging.component.html',
  styleUrls: ['./account-aging.component.css']
})
export class AccountAgingComponent implements OnInit, OnDestroy {

  public allTransactions: any[] = [];
  public tillDate: any;
  public pdf_url: string;
  public doctor: PaginatedDropdown;

  displayColumns = [
    'doctor_name',
    'invoice_outstanding',
    'unadjusted_dr_cr_amount',
    'net_outstanding',
    'not_due_amount',
    'days_1_to_30',
    'days_31_to_60',
    'days_61_to_90',
    'days_91_to_120',
    'days_121_and_above',
  ];
  displayHeaders = [
    'Doctor Name',
    'Total Outstanding',
    'Unadjusted DR/CR Amount',
    'Net Outstanding',
    'Not Due Amount',
    '1-30',
    '31-60',
    '61-90',
    '91-120',
    '121 & Above',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private dropdownService: CommonDropdownService,
  ) {
    this.doctor = new PaginatedDropdown(this.api, this.dropdownService, 'doctor');
  }

  ngOnInit(): void {
    this.speaker.listData = this.allTransactions;
    this.doctor.selectedId = 0;
    this.doctor.init();
  }

  ngOnDestroy(): void {
    this.doctor.destroy();
  }

  getReportDetails(data: any) {
    this.allTransactions = [];
    this.speaker.isLoading = true;
    this.api.callRoute('account', '/list/aging', data).subscribe({
      next: (res) => {
        this.speaker.isLoading = false;
        if (res?.status == false) {
          this.snackbar.info(res.message);
        } else {
          this.allTransactions = res.data;
          this.speaker.listData = this.allTransactions;
        }
      },
      error: () => { this.speaker.isLoading = false; }
    });
  }

  generateReport() {
    if (!validateRequired(
      [{ value: this.tillDate, label: 'Till Date' }],
      this.snackbar,
    )) {
      return;
    }
    const data = {
      end_date: this.tillDate,
      doctor_id: this.doctor.selectedId,
    };
    this.speaker.listData = [];
    this.getReportDetails(data);
    const formattedTillDate = this.tillDate.toISOString();
    this.pdf_url = 'api/account/outstanding_receivbles_pdf?doctor_id=' + this.doctor.selectedId + '&till_date=' + formattedTillDate;
    this.speaker.model = 'account';
    this.speaker.displayColumns = this.displayColumns;
    this.speaker.displayHeaders = this.displayHeaders;
    this.speaker.setListData(this.allTransactions, 0, 0, 0);
  }
}
